// The player's answer to "why do you play?" from the mobile intro tour
// (betup-server-api `UserPurpose`, table qbet_user_purpose).
export const USER_PURPOSE_LABELS: { [purpose: string]: string } = {
    FOR_FUN: 'Predicts for fun',
    COMPETE: 'Competes against others',
    PRACTICE_REAL_BETTING: 'Practises for real-money betting',
    PRO_PREDICTIONS: 'Learns from experienced players',
};

export const userPurposeLabel = (purpose?: string | null) =>
    purpose ? (USER_PURPOSE_LABELS[purpose] ?? purpose) : 'Not answered';

// The glow colours of the purpose cards in the app, so the pie reads like the slide.
const USER_PURPOSE_COLORS: { [purpose: string]: string } = {
    FOR_FUN: '#FFC400',
    COMPETE: '#B36CFF',
    PRACTICE_REAL_BETTING: '#3DDC84',
    PRO_PREDICTIONS: '#3FE0FF',
};

export const userPurposeColor = (purpose: string) => USER_PURPOSE_COLORS[purpose] ?? '#9AA5B4';
